(() => {
  'use strict';

  const ROOT_ID = 'woofshack-futterrechner';
  const STYLE_ID = 'woofshack-futterrechner-styles-v2';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      #${ROOT_ID}.wsfc {
        --wsfc-text: #222;
        --wsfc-muted: #686868;
        --wsfc-border: #dedede;
        --wsfc-soft: #f7f7f7;
        --wsfc-result: #eef8f2;
        --wsfc-result-border: #cee5d6;
        --wsfc-yellow: #FFD814;
        --wsfc-yellow-border: #d8b900;
        --wsfc-danger: #9b111e;

        width: 100%;
        max-width: 980px;
        margin: 32px auto;
        color: var(--wsfc-text);
        font: inherit;
        line-height: 1.5;
      }

      #${ROOT_ID}.wsfc * {
        box-sizing: border-box;
      }

      #${ROOT_ID} .wsfc__intro {
        text-align: center;
        margin: 0 auto 22px;
      }

      #${ROOT_ID} .wsfc__eyebrow {
        margin: 0 0 4px;
        font-size: 12px;
        font-weight: 800;
        letter-spacing: .12em;
      }

      #${ROOT_ID} .wsfc__intro h2 {
        margin: 0 0 10px;
        font-size: clamp(27px, 4vw, 40px);
        line-height: 1.15;
      }

      #${ROOT_ID} .wsfc__intro p {
        max-width: 760px;
        margin: 0 auto;
      }

      #${ROOT_ID} .wsfc__notice,
      #${ROOT_ID} .wsfc__footnote {
        border: 1px solid var(--wsfc-border);
        border-radius: 12px;
        background: var(--wsfc-soft);
        padding: 14px 16px;
      }

      #${ROOT_ID} .wsfc__tabs {
        display: flex;
        gap: 8px;
        overflow-x: auto;
        padding: 2px 0;
        margin: 18px 0;
        scrollbar-width: thin;
      }

      #${ROOT_ID} .wsfc__tab {
        appearance: none;
        border: 1px solid var(--wsfc-border);
        border-radius: 999px;
        background: #fff;
        color: var(--wsfc-text);
        padding: 10px 16px;
        font: inherit;
        font-weight: 700;
        white-space: nowrap;
        cursor: pointer;
      }

      #${ROOT_ID} .wsfc__tab.is-active {
        background: #222;
        border-color: #222;
        color: #fff;
      }

      #${ROOT_ID} .wsfc__panel {
        border: 1px solid var(--wsfc-border);
        border-radius: 16px;
        background: #fff;
        padding: 20px;
      }

      #${ROOT_ID} .wsfc__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
      }

      #${ROOT_ID} .wsfc__grid--analytics {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }

      #${ROOT_ID} .wsfc__field {
        margin-bottom: 16px;
      }

      #${ROOT_ID} .wsfc__field label,
      #${ROOT_ID} .wsfc__fieldset legend {
        display: block;
        margin-bottom: 7px;
        font-weight: 700;
      }

      #${ROOT_ID} .wsfc__field input,
      #${ROOT_ID} .wsfc__field select {
        width: 100%;
        min-height: 46px;
        border: 1px solid #bcbcbc;
        border-radius: 9px;
        background: #fff;
        color: #222;
        padding: 10px 12px;
        font: inherit;
      }

      #${ROOT_ID} .wsfc__field input:focus,
      #${ROOT_ID} .wsfc__field select:focus,
      #${ROOT_ID} .wsfc__tab:focus-visible,
      #${ROOT_ID} .wsfc__button:focus-visible {
        outline: 2px solid #222;
        outline-offset: 2px;
      }

      #${ROOT_ID} .wsfc__field small,
      #${ROOT_ID} .wsfc__helper,
      #${ROOT_ID} .wsfc__muted {
        color: var(--wsfc-muted);
        font-size: 13px;
        line-height: 1.45;
      }

      #${ROOT_ID} .wsfc__input-unit {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      #${ROOT_ID} .wsfc__input-unit input {
        flex: 1;
      }

      #${ROOT_ID} .wsfc__input-unit span {
        min-width: 46px;
        font-weight: 700;
      }

      #${ROOT_ID} .wsfc__fieldset {
        margin: 4px 0 18px;
        border: 1px solid var(--wsfc-border);
        border-radius: 12px;
        padding: 16px;
      }

      #${ROOT_ID} .wsfc__choice {
        display: flex;
        flex-wrap: wrap;
        gap: 14px;
        margin-bottom: 14px;
      }

      #${ROOT_ID} .wsfc__choice label,
      #${ROOT_ID} .wsfc__checkrow label {
        display: flex;
        gap: 8px;
        align-items: flex-start;
      }

      #${ROOT_ID} .wsfc__checkrow {
        margin: 12px 0;
      }

      #${ROOT_ID} .wsfc__checkrow input[type="checkbox"] {
      width: 18px;
      height: 18px;
      min-width: 18px;
      flex: 0 0 18px;
      margin: .2em 0 0 0;
      }

      #${ROOT_ID} .wsfc__choice input[type="radio"] {
      width: 18px;
      height: 18px;
      min-width: 18px;
      flex: 0 0 18px;
      margin: .2em 0 0 0;
      }

      #${ROOT_ID} .wsfc__button {
        width: 100%;
        border: 1px solid var(--wsfc-yellow-border);
        border-radius: 10px;
        background: var(--wsfc-yellow);
        color: #111;
        padding: 13px 18px;
        font: inherit;
        font-weight: 800;
        cursor: pointer;
      }

      #${ROOT_ID} .wsfc__button:hover {
        filter: brightness(.98);
      }

      #${ROOT_ID} .wsfc__error {
        margin-top: 12px;
        color: var(--wsfc-danger);
        font-weight: 700;
      }

      #${ROOT_ID} .wsfc__result {
        margin-top: 20px;
        border: 1px solid var(--wsfc-result-border);
        border-radius: 14px;
        background: var(--wsfc-result);
        padding: 20px;
      }

      #${ROOT_ID} .wsfc__result h3 {
        margin: 0 0 12px;
        font-size: clamp(23px, 3vw, 30px);
      }

      #${ROOT_ID} .wsfc__result-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        margin: 14px 0;
      }

      #${ROOT_ID} .wsfc__metric {
        border: 1px solid #d7e6da;
        border-radius: 10px;
        background: #fff;
        padding: 14px;
      }

      #${ROOT_ID} .wsfc__metric strong {
        display: block;
        margin-top: 5px;
        font-size: clamp(22px, 3vw, 28px);
        line-height: 1.2;
      }

      #${ROOT_ID} .wsfc__result ul {
        padding-left: 20px;
      }

      #${ROOT_ID} .wsfc__two-cards {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
        margin: 14px 0;
      }

      #${ROOT_ID} .wsfc__foodcard {
        border: 1px solid var(--wsfc-border);
        border-radius: 12px;
        background: var(--wsfc-soft);
        padding: 16px;
      }

      #${ROOT_ID} .wsfc__foodcard h3 {
        margin: 0 0 14px;
      }

      #${ROOT_ID} .wsfc__range {
        width: 100%;
        accent-color: #222;
      }

      #${ROOT_ID} .wsfc__footnote {
        margin-top: 18px;
        font-size: 13px;
      }

      #${ROOT_ID} .wsfc__inline-note {
        margin: 12px 0 0;
        padding: 12px 14px;
        border-left: 3px solid #222;
        background: #fafafa;
        font-size: 14px;
      }

      @media (max-width: 720px) {
        #${ROOT_ID}.wsfc {
          margin: 22px 0;
        }

        #${ROOT_ID} .wsfc__panel {
          padding: 15px;
        }

        #${ROOT_ID} .wsfc__grid,
        #${ROOT_ID} .wsfc__grid--analytics,
        #${ROOT_ID} .wsfc__two-cards,
        #${ROOT_ID} .wsfc__result-grid {
          grid-template-columns: 1fr;
        }

        #${ROOT_ID} .wsfc__tab {
          padding: 9px 13px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function calculatorMarkup() {
    return `
      <div class="wsfc__intro">
        <p class="wsfc__eyebrow"></p>
        <h2>Wie viel Futter braucht mein Hund?</h2>
        <p>
          Berechne einen <strong>Orientierungswert</strong> für Tagesenergie
          und Futtermenge – FEDIAF-basiert und passend zum Energiegehalt
          deines Futters.
        </p>
      </div>

      <div class="wsfc__notice">
        <strong>Wichtig:</strong>
        Der Rechner ist für grundsätzlich gesunde Hunde gedacht.
        Das Ergebnis ist ein Ausgangswert und ersetzt keine individuelle
        tierärztliche Ernährungsberatung.
      </div>

      <div
        class="wsfc__tabs"
        role="tablist"
        aria-label="Woofshack Futterrechner"
      >
        <button
          type="button"
          class="wsfc__tab is-active"
          data-wsfc-tab="amount"
          role="tab"
          aria-selected="true"
        >
          Futtermenge
        </button>

        <button
          type="button"
          class="wsfc__tab"
          data-wsfc-tab="mixed"
          role="tab"
          aria-selected="false"
        >
          Mischfütterung
        </button>

        <button
          type="button"
          class="wsfc__tab"
          data-wsfc-tab="dm"
          role="tab"
          aria-selected="false"
        >
          Trockensubstanz
        </button>
      </div>
            <section
        class="wsfc__panel"
        data-wsfc-panel="amount"
      >
        <form data-wsfc-form="amount" novalidate>

          <div class="wsfc__grid">

            <div class="wsfc__field">
              <label for="wsfc-stage">Lebensphase</label>
              <select id="wsfc-stage">
                <option value="adult">Erwachsener Hund</option>
                <option value="puppy">Welpe (8 Wochen bis 1 Jahr)</option>
              </select>
            </div>

            <div class="wsfc__field">
              <label for="wsfc-weight">Aktuelles Körpergewicht</label>
              <div class="wsfc__input-unit">
                <input
                  id="wsfc-weight"
                  type="number"
                  min="0.5"
                  max="120"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 20"
                >
                <span>kg</span>
              </div>
            </div>

            <div class="wsfc__field" data-wsfc-adult>
              <label for="wsfc-activity">Aktivität</label>
              <select id="wsfc-activity">
                <option value="95">
                  Eher ruhig – unter ca. 1 h/Tag
                </option>

                <option value="110" selected>
                  Normal aktiv – ca. 1–3 h/Tag
                </option>

                <option value="125">
                  Aktiv – ca. 1–3 h/Tag, höhere Belastung
                </option>
              </select>

              <small>
                FEDIAF-basierte Ausgangswerte:
                95 / 110 / 125 kcal ME × kg<sup>0,75</sup>.
              </small>
            </div>

            <div
              class="wsfc__field"
              data-wsfc-puppy
              hidden
            >
              <label for="wsfc-mature-weight">
                Erwartetes Erwachsenengewicht
              </label>

              <div class="wsfc__input-unit">
                <input
                  id="wsfc-mature-weight"
                  type="number"
                  min="1"
                  max="120"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 30"
                >
                <span>kg</span>
              </div>

              <small>
                Bei Unsicherheit bitte Rasse-/Züchterangaben oder
                eine tierärztliche Einschätzung heranziehen.
              </small>
            </div>
            <div class="wsfc__field">
  <label for="wsfc-food-type">
    Futterart
  </label>

  <select id="wsfc-food-type">
    <option value="dry" selected>
      Trockenfutter
    </option>

    <option value="wet">
      Nassfutter
    </option>
  </select>

  <small>
    Die Futterart verändert die Berechnungsformel nicht.
    Entscheidend ist der Energiegehalt des konkreten Futters.
  </small>
            </div>
            <div class="wsfc__field">
              <label for="wsfc-bcs">
                Körperkondition
              </label>

              <select id="wsfc-bcs">
                <option value="ideal" selected>
                  Ideal / normal
                </option>

                <option value="slim">
                  Eher schlank
                </option>

                <option value="heavy">
                  Eher kräftig
                </option>

                <option value="obese">
                  Deutlich übergewichtig
                </option>

                <option value="unsure">
                  Unsicher
                </option>
              </select>

              <small>
                Die Auswahl verändert die Berechnung nicht automatisch;
                sie steuert nur den Hinweis zum Ergebnis.
              </small>
            </div>

          </div>

          <fieldset class="wsfc__fieldset">

            <legend>
              Energiegehalt des Futters
            </legend>

            <div class="wsfc__choice">

              <label>
                <input
                  type="radio"
                  name="wsfc-energy-mode"
                  value="known"
                  checked
                >
                Energiegehalt ist bekannt
              </label>

              <label>
                <input
                  type="radio"
                  name="wsfc-energy-mode"
                  value="estimate"
                >
                Energiegehalt näherungsweise berechnen
              </label>

            </div>

            <div data-wsfc-energy-known>

              <div class="wsfc__grid">

                <div class="wsfc__field">
                  <label for="wsfc-energy">
                    Metabolisierbare Energie (ME)
                  </label>

                  <input
                    id="wsfc-energy"
                    type="number"
                    min="1"
                    step="0.1"
                    inputmode="decimal"
                    placeholder="z. B. 380"
                  >
                </div>

                <div class="wsfc__field">
                  <label for="wsfc-energy-unit">
                    Einheit
                  </label>

                  <select id="wsfc-energy-unit">
                    <option value="100g">
                      kcal / 100 g
                    </option>

                    <option value="kg">
                      kcal / kg
                    </option>
                  </select>
                </div>

              </div>

              <small>
                Suche auf Verpackung oder Produktseite nach
                „Energie“, „ME“, „metabolisierbare Energie“,
                kcal/100 g oder kcal/kg.
              </small>

            </div>

            <div
              data-wsfc-energy-estimate
              hidden
            >

              <p class="wsfc__helper">
                Gib die analytischen Bestandteile in % der
                Frischsubstanz ein. Die daraus ermittelte
                metabolisierbare Energie ist eine Näherung.
              </p>

              <div class="wsfc__grid wsfc__grid--analytics">

                <div class="wsfc__field">
                  <label for="wsfc-protein">
                    Rohprotein %
                  </label>

                  <input
                    id="wsfc-protein"
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                  >
                </div>

                <div class="wsfc__field">
                  <label for="wsfc-fat">
                    Rohfett %
                  </label>

                  <input
                    id="wsfc-fat"
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                  >
                </div>

                <div class="wsfc__field">
                  <label for="wsfc-fibre">
                    Rohfaser %
                  </label>

                  <input
                    id="wsfc-fibre"
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                  >
                </div>

                <div class="wsfc__field">
                  <label for="wsfc-ash">
                    Rohasche %
                  </label>

                  <input
                    id="wsfc-ash"
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                  >
                </div>

                <div class="wsfc__field">
                  <label for="wsfc-moisture">
                    Feuchtigkeit %
                  </label>

                  <input
                    id="wsfc-moisture"
                    type="number"
                    min="0"
                    max="99"
                    step="0.1"
                  >
                </div>

              </div>

              <small>
                Wenn der Hersteller einen ME-/Kalorienwert angibt,
                verwende bevorzugt diesen. Die hier berechnete ME
                ist nur eine Schätzung.
              </small>

            </div>

          </fieldset>

          <div class="wsfc__checkrow">
            <label>
              <input
                id="wsfc-treats"
                type="checkbox"
              >
              Bis zu 10 % des Tagesenergiebedarfs für
              Snacks/Leckerlis reservieren
            </label>
          </div>

          <div class="wsfc__checkrow">
            <label>
              <input
                id="wsfc-healthy"
                type="checkbox"
              >
              Mein Hund ist grundsätzlich gesund und benötigt
              keine tierärztlich verordnete Diät.
            </label>
          </div>

          <button
            class="wsfc__button"
            type="submit"
          >
            Futtermenge berechnen
          </button>

          <div
            class="wsfc__error"
            data-wsfc-error="amount"
            role="alert"
            hidden
          ></div>

        </form>

        <div
          class="wsfc__result"
          data-wsfc-result="amount"
          aria-live="polite"
          hidden
        ></div>

      </section>


      <section
        class="wsfc__panel"
        data-wsfc-panel="mixed"
        hidden
      >

        <form
          data-wsfc-form="mixed"
          novalidate
        >

          <div class="wsfc__grid">

            <div class="wsfc__field">

              <label for="wsfc-mix-stage">
                Lebensphase
              </label>

              <select id="wsfc-mix-stage">

                <option value="adult">
                  Erwachsener Hund
                </option>

                <option value="puppy">
                  Welpe (8 Wochen bis 1 Jahr)
                </option>

              </select>

            </div>


            <div class="wsfc__field">

              <label for="wsfc-mix-weight">
                Aktuelles Körpergewicht
              </label>

              <div class="wsfc__input-unit">

                <input
                  id="wsfc-mix-weight"
                  type="number"
                  min="0.5"
                  max="120"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 20"
                >

                <span>kg</span>

              </div>

            </div>


            <div
              class="wsfc__field"
              data-wsfc-mix-adult
            >

              <label for="wsfc-mix-activity">
                Aktivität
              </label>

              <select id="wsfc-mix-activity">

                <option value="95">
                  Eher ruhig
                </option>

                <option
                  value="110"
                  selected
                >
                  Normal aktiv
                </option>

                <option value="125">
                  Aktiv
                </option>

              </select>

            </div>


            <div
              class="wsfc__field"
              data-wsfc-mix-puppy
              hidden
            >

              <label for="wsfc-mix-mature">
                Erwartetes Erwachsenengewicht
              </label>

              <div class="wsfc__input-unit">

                <input
                  id="wsfc-mix-mature"
                  type="number"
                  min="1"
                  max="120"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 30"
                >

                <span>kg</span>

              </div>

            </div>

          </div>


          <div class="wsfc__two-cards">

            <div class="wsfc__foodcard">

              <h3>🟤 Trockenfutter</h3>

              <div class="wsfc__field">

                <label for="wsfc-dry-energy">
                  Energie
                </label>

                <input
                  id="wsfc-dry-energy"
                  type="number"
                  min="1"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 380"
                >

              </div>

              <div class="wsfc__field">

                <label for="wsfc-dry-unit">
                  Einheit
                </label>

                <select id="wsfc-dry-unit">

                  <option value="100g">
                    kcal / 100 g
                  </option>

                  <option value="kg">
                    kcal / kg
                  </option>

                </select>

              </div>

            </div>


            <div class="wsfc__foodcard">

              <h3>🥫 Nassfutter</h3>

              <div class="wsfc__field">

                <label for="wsfc-wet-energy">
                  Energie
                </label>

                <input
                  id="wsfc-wet-energy"
                  type="number"
                  min="1"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 110"
                >

              </div>

              <div class="wsfc__field">

                <label for="wsfc-wet-unit">
                  Einheit
                </label>

                <select id="wsfc-wet-unit">

                  <option value="100g">
                    kcal / 100 g
                  </option>

                  <option value="kg">
                    kcal / kg
                  </option>

                </select>

              </div>

            </div>

          </div>


          <div class="wsfc__field">

            <label for="wsfc-mix-slider">

              Energieaufteilung:

              <strong>
                <span data-wsfc-dry-share>50</span> % Trocken /
                <span data-wsfc-wet-share>50</span> % Nass
              </strong>

            </label>

            <input
              id="wsfc-mix-slider"
              class="wsfc__range"
              type="range"
              min="10"
              max="90"
              step="5"
              value="50"
            >

            <small>
              Die Prozentwerte beziehen sich auf die
              <strong>Energie</strong>,
              nicht auf dieselbe Grammmenge.
            </small>

          </div>


          <div class="wsfc__checkrow">

            <label>

              <input
                id="wsfc-mix-treats"
                type="checkbox"
              >

              Bis zu 10 % für Snacks/Leckerlis reservieren

            </label>

          </div>


          <div class="wsfc__checkrow">

            <label>

              <input
                id="wsfc-mix-healthy"
                type="checkbox"
              >

              Mein Hund ist grundsätzlich gesund und benötigt
              keine tierärztlich verordnete Diät.

            </label>

          </div>


          <button
            class="wsfc__button"
            type="submit"
          >
            Mischfütterung berechnen
          </button>


          <div
            class="wsfc__error"
            data-wsfc-error="mixed"
            role="alert"
            hidden
          ></div>

        </form>


        <div
          class="wsfc__result"
          data-wsfc-result="mixed"
          aria-live="polite"
          hidden
        ></div>

      </section>
            <section
        class="wsfc__panel"
        data-wsfc-panel="dm"
        hidden
      >

        <form
          data-wsfc-form="dm"
          novalidate
        >

          <p class="wsfc__helper">
            Vergleiche Nährstoffe von Nass- und Trockenfutter richtig miteinander.
            Wähle einen Nährstoff, z. B. Rohprotein oder Rohfett, und trage bei beiden Futtern den Wert vom Etikett sowie die Feuchtigkeit ein.
          </p>

          <div class="wsfc__two-cards">

            <div class="wsfc__foodcard">

              <h3>Futter A</h3>

              <div class="wsfc__field">

                <label for="wsfc-a-nutrient">
                  Nährstoffwert laut Etikett (z. B. Rohprotein) %
                </label>

                <input
                  id="wsfc-a-nutrient"
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 10"
                >

              </div>

              <div class="wsfc__field">

                <label for="wsfc-a-moisture">
                  Feuchtigkeit laut Etikett %
                </label>

                <input
                  id="wsfc-a-moisture"
                  type="number"
                  min="0"
                  max="99"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 75"
                >

              </div>

            </div>


            <div class="wsfc__foodcard">

              <h3>
                Futter B
                <span class="wsfc__muted">(optional)</span>
              </h3>

              <div class="wsfc__field">

                <label for="wsfc-b-nutrient">
                  Nährstoffwert laut Etikett (z. B. Rohprotein) %
                </label>

                <input
                  id="wsfc-b-nutrient"
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 25"
                >

              </div>

              <div class="wsfc__field">

                <label for="wsfc-b-moisture">
                  Feuchtigkeit laut Etikett %
                </label>

                <input
                  id="wsfc-b-moisture"
                  type="number"
                  min="0"
                  max="99"
                  step="0.1"
                  inputmode="decimal"
                  placeholder="z. B. 10"
                >

              </div>

            </div>

          </div>


          <button
            class="wsfc__button"
            type="submit"
          >
            Trockensubstanz berechnen
          </button>


          <div
            class="wsfc__error"
            data-wsfc-error="dm"
            role="alert"
            hidden
          ></div>

        </form>


        <div
          class="wsfc__result"
          data-wsfc-result="dm"
          aria-live="polite"
          hidden
        ></div>

      </section>


      <div class="wsfc__footnote">

        <strong>Wissenschaftliche Grundlage:</strong>
        FEDIAF Nutritional Guidelines 2025.

        Die verwendeten Formeln liefern Orientierungswerte.
        Individuelle Energiebedarfe können deutlich abweichen.

        Bei Erkrankungen, deutlichem Über-/Untergewicht,
        gezielter Gewichtsreduktion, Trächtigkeit/Laktation,
        tierärztlicher Diät oder Hochleistungs-/Arbeitshunden
        bitte individuell fachlich abklären.

      </div>
    `;
  }


  function init(root) {

    if (
      !root ||
      root.dataset.wsfcReady === 'true'
    ) {
      return;
    }

    root.dataset.wsfcReady = 'true';
    root.classList.add('wsfc');

    root.innerHTML = calculatorMarkup();


    const $ = (selector) =>
      root.querySelector(selector);


    const $$ = (selector) =>
      Array.from(
        root.querySelectorAll(selector)
      );


    const numberValue = (selector) => {

      const element =
        typeof selector === 'string'
          ? $(selector)
          : selector;

      if (!element) {
        return NaN;
      }

      return parseFloat(
        String(element.value).replace(',', '.')
      );

    };


    const isFiniteNumber = (value) =>
      Number.isFinite(value);


    const fmt0 = (value) =>
      Math.round(value).toLocaleString('de-DE');


    const fmt1 = (value) =>
      (Math.round(value * 10) / 10)
        .toLocaleString(
          'de-DE',
          {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
          }
        );


    function kcalPer100(
      value,
      unit
    ) {

      return unit === 'kg'
        ? value / 10
        : value;

    }


    function adultEnergy(
      weight,
      factor
    ) {

      return factor *
        Math.pow(weight, 0.75);

    }


    function puppyEnergy(
      weight,
      matureWeight
    ) {

      return (
        254.1 -
        135 *
        (
          weight /
          matureWeight
        )
      ) *
      Math.pow(weight, 0.75);

    }


    function getBaseEnergy(
      stage,
      weight,
      factor,
      matureWeight
    ) {

      if (
        !isFiniteNumber(weight) ||
        weight < 0.5 ||
        weight > 120
      ) {

        throw new Error(
          'Bitte gib ein Körpergewicht zwischen 0,5 und 120 kg ein.'
        );

      }


      if (stage === 'adult') {

        return adultEnergy(
          weight,
          factor
        );

      }


      if (
        !isFiniteNumber(matureWeight) ||
        matureWeight < 1 ||
        matureWeight > 120
      ) {

        throw new Error(
          'Bitte gib ein erwartetes Erwachsenengewicht zwischen 1 und 120 kg ein.'
        );

      }


      if (
        matureWeight < weight
      ) {

        throw new Error(
          'Das erwartete Erwachsenengewicht darf nicht unter dem aktuellen Körpergewicht liegen.'
        );

      }


      const kcal =
        puppyEnergy(
          weight,
          matureWeight
        );


      if (
        !isFiniteNumber(kcal) ||
        kcal <= 0
      ) {

        throw new Error(
          'Mit diesen Angaben konnte kein plausibler Welpen-Energiebedarf berechnet werden.'
        );

      }


      return kcal;

    }


    function validateEnergy(
      kcal100
    ) {

      if (
        !isFiniteNumber(kcal100) ||
        kcal100 <= 0
      ) {

        throw new Error(
          'Bitte gib einen gültigen Energiegehalt ein.'
        );

      }


      if (
        kcal100 < 20 ||
        kcal100 > 700
      ) {

        throw new Error(
          'Der Energiegehalt wirkt unplausibel. Bitte prüfe Wert und Einheit.'
        );

      }

    }


    function estimateME() {

      const protein =
        numberValue('#wsfc-protein');

      const fat =
        numberValue('#wsfc-fat');

      const fibre =
        numberValue('#wsfc-fibre');

      const ash =
        numberValue('#wsfc-ash');

      const moisture =
        numberValue('#wsfc-moisture');


      const values = [
        protein,
        fat,
        fibre,
        ash,
        moisture
      ];


      if (
        values.some(
          value =>
            !isFiniteNumber(value) ||
            value < 0
        )
      ) {

        throw new Error(
          'Bitte fülle alle analytischen Bestandteile korrekt aus.'
        );

      }


      if (
        moisture >= 100
      ) {

        throw new Error(
          'Die Feuchtigkeit muss unter 100 % liegen.'
        );

      }


      const sum =
        protein +
        fat +
        fibre +
        ash +
        moisture;


      if (
        sum >= 100
      ) {

        throw new Error(
          'Rohprotein + Rohfett + Rohfaser + Rohasche + Feuchtigkeit müssen zusammen unter 100 % liegen.'
        );

      }


      const nfe =
        100 - sum;


      const dryMatter =
        100 - moisture;


      if (
        dryMatter <= 0
      ) {

        throw new Error(
          'Aus der Feuchtigkeitsangabe ergibt sich keine gültige Trockensubstanz.'
        );

      }


      const fibreDM =
        (
          fibre /
          dryMatter
        ) *
        100;


      /*
        FEDIAF / EN-16967-basierte
        Vorhersagemethode.

        Ergebnis:
        kcal pro 100 g Futter.
      */

      const grossEnergy =
        (5.7 * protein) +
        (9.4 * fat) +
        (
          4.1 *
          (
            nfe +
            fibre
          )
        );


      const energyDigestibilityPercent =
        91.2 -
        (
          1.43 *
          fibreDM
        );


      if (
        energyDigestibilityPercent <= 0 ||
        energyDigestibilityPercent > 100
      ) {

        throw new Error(
          'Die analytischen Angaben ergeben eine unplausible geschätzte Energieverdaulichkeit.'
        );

      }


      const digestibleEnergy =
        grossEnergy *
        (
          energyDigestibilityPercent /
          100
        );


      const metabolizableEnergy =
        digestibleEnergy -
        (
          1.04 *
          protein
        );


      validateEnergy(
        metabolizableEnergy
      );


      return {

        me:
          metabolizableEnergy,

        nfe:
          nfe,

        dryMatter:
          dryMatter,

        fibreDM:
          fibreDM,

        energyDigestibilityPercent:
          energyDigestibilityPercent

      };

    }


    function bcsNote(
      value
    ) {

      if (
        value === 'slim'
      ) {

        return (
          'Bei eher schlanker Körperkondition sollten Gewichtsentwicklung und mögliche Ursachen beobachtet werden. Bei unerklärlichem Gewichtsverlust bitte tierärztlich abklären.'
        );

      }


      if (
        value === 'heavy'
      ) {

        return (
          'Die Berechnung basiert auf dem aktuellen Körpergewicht und ist keine Diätempfehlung. Bei eher kräftiger Körperkondition sollte die geeignete Energiezufuhr individuell überprüft werden.'
        );

      }


      if (
        value === 'obese'
      ) {

        return (
          'Bei deutlichem Übergewicht sollte keine starke eigenständige Kalorienreduktion anhand dieses Rechners erfolgen. Bitte die geeignete Energiezufuhr individuell fachlich festlegen.'
        );

      }


      if (
        value === 'unsure'
      ) {

        return (
          'Wenn du die Körperkondition nicht sicher einschätzen kannst, orientiere dich zusätzlich am 9-Punkte-Body-Condition-Score und lass dich bei Unsicherheit fachlich beraten.'
        );

      }


      return (
        'Für gesunde Hunde wird als Orientierung eine ideale Körperkondition im Bereich BCS 4–5/9 angestrebt.'
      );

    }


    function puppyResultNote() {

      return `
        <p class="wsfc__inline-note">

          <strong>
            Welpen-Hinweis:
          </strong>

          Wachstum, Körpergewicht und Körperkondition
          regelmäßig kontrollieren.

          Der berechnete Wert ist ein Orientierungswert
          und sollte an die individuelle Entwicklung
          angepasst werden – besonders bei großen und
          sehr großen Hunden.

        </p>
      `;

    }


    function showError(
      type,
      message
    ) {

      const error =
        $(
          `[data-wsfc-error="${type}"]`
        );


      if (!error) {
        return;
      }


      error.textContent =
        message;


      error.hidden =
        false;

    }


    function clearFeedback(
      type
    ) {

      const error =
        $(
          `[data-wsfc-error="${type}"]`
        );


      const result =
        $(
          `[data-wsfc-result="${type}"]`
        );


      if (error) {
        error.hidden = true;
      }


      if (result) {
        result.hidden = true;
      }

    }


    function scrollToResult(
      result
    ) {

      if (!result) {
        return;
      }


      result.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });

    }


    /*
      TABS
    */

    $$('.wsfc__tab').forEach(
      button => {

        button.addEventListener(
          'click',
          () => {

            const target =
              button.dataset.wsfcTab;


            $$('.wsfc__tab')
              .forEach(
                tab => {

                  tab.classList.toggle(
                    'is-active',
                    tab === button
                  );


                  tab.setAttribute(
                    'aria-selected',
                    tab === button
                      ? 'true'
                      : 'false'
                  );

                }
              );


            $$('[data-wsfc-panel]')
              .forEach(
                panel => {

                  panel.hidden =
                    panel.dataset.wsfcPanel !==
                    target;

                }
              );

          }
        );

      }
    );


    /*
      LEBENSPHASE
      FUTTERMENGE
    */

    $('#wsfc-stage')
      .addEventListener(
        'change',
        event => {

          const puppy =
            event.target.value ===
            'puppy';


          $$('[data-wsfc-adult]')
            .forEach(
              element => {
                element.hidden =
                  puppy;
              }
            );


          $$('[data-wsfc-puppy]')
            .forEach(
              element => {
                element.hidden =
                  !puppy;
              }
            );

        }
      );


    /*
      LEBENSPHASE
      MISCHFÜTTERUNG
    */

    $('#wsfc-mix-stage')
      .addEventListener(
        'change',
        event => {

          const puppy =
            event.target.value ===
            'puppy';


          $$('[data-wsfc-mix-adult]')
            .forEach(
              element => {
                element.hidden =
                  puppy;
              }
            );


          $$('[data-wsfc-mix-puppy]')
            .forEach(
              element => {
                element.hidden =
                  !puppy;
              }
            );

        }
      );


    /*
      ENERGIEGEHALT
      BEKANNT / SCHÄTZEN
    */

    $$(
      'input[name="wsfc-energy-mode"]'
    )
      .forEach(
        radio => {

          radio.addEventListener(
            'change',
            () => {

              const mode =
                $(
                  'input[name="wsfc-energy-mode"]:checked'
                ).value;


              $('[data-wsfc-energy-known]')
                .hidden =
                  mode !== 'known';


              $('[data-wsfc-energy-estimate]')
                .hidden =
                  mode !== 'estimate';

            }
          );

        }
      );
          /*
      FUTTERMENGE BERECHNEN
    */

    $('[data-wsfc-form="amount"]')
      .addEventListener(
        'submit',
        event => {

          event.preventDefault();

          clearFeedback(
            'amount'
          );


          try {

            if (
              !$('#wsfc-healthy').checked
            ) {

              throw new Error(
                'Bitte bestätige, dass der Rechner für einen grundsätzlich gesunden Hund verwendet wird.'
              );

            }


            const stage =
              $('#wsfc-stage').value;


            const weight =
              numberValue(
                '#wsfc-weight'
              );


            const activityFactor =
              numberValue(
                '#wsfc-activity'
              );


            const matureWeight =
              numberValue(
                '#wsfc-mature-weight'
              );


            const dailyEnergy =
              getBaseEnergy(
                stage,
                weight,
                activityFactor,
                matureWeight
              );


            const reserveTreats =
              $('#wsfc-treats').checked;


            const mainFoodEnergy =
              reserveTreats
                ? dailyEnergy * 0.90
                : dailyEnergy;


            const mode =
              $(
                'input[name="wsfc-energy-mode"]:checked'
              ).value;


            let kcal100;
            let estimate = null;


            if (
              mode === 'known'
            ) {

              const enteredEnergy =
                numberValue(
                  '#wsfc-energy'
                );


              if (
                !isFiniteNumber(
                  enteredEnergy
                ) ||
                enteredEnergy <= 0
              ) {

                throw new Error(
                  'Bitte gib den Energiegehalt des Futters ein.'
                );

              }


              kcal100 =
                kcalPer100(
                  enteredEnergy,
                  $('#wsfc-energy-unit').value
                );


              validateEnergy(
                kcal100
              );

            } else {

              estimate =
                estimateME();


              kcal100 =
                estimate.me;

            }


            const gramsPerDay =
              mainFoodEnergy /
              (
                kcal100 /
                100
              );


            if (
              !isFiniteNumber(
                gramsPerDay
              ) ||
              gramsPerDay <= 0
            ) {

              throw new Error(
                'Die Futtermenge konnte mit diesen Angaben nicht sinnvoll berechnet werden.'
              );

            }


            const result =
              $(
                '[data-wsfc-result="amount"]'
              );


            const stageDescription =
              stage === 'adult'
                ? $('#wsfc-activity')
                    .selectedOptions[0]
                    .textContent
                : 'Welpe · FEDIAF-basierte Berechnung während des Wachstums';
            const foodType =
            $('#wsfc-food-type').value;

            const foodTypeLabel =
            foodType === 'wet'
            ? 'Nassfutter'
            : 'Trockenfutter';

            const estimateHtml =
              estimate
                ? `
                  <p>
                    <strong>
                      Geschätzter Energiegehalt des Futters:
                    </strong>
                    ca. ${fmt0(kcal100)} kcal/100 g.
                  </p>

                  <p class="wsfc__helper">
                    Dieser Wert wurde aus den analytischen Bestandteilen geschätzt.
                    Wenn der Hersteller einen ME-/Kalorienwert angibt,
                    verwende bevorzugt diesen.
                  </p>
                `
                : '';


            const treatHtml =
              reserveTreats
                ? `
                  <li>
                    Für Snacks reserviert:
                    bis zu ca.
                    <strong>
                      ${fmt0(
                        dailyEnergy *
                        0.10
                      )} kcal/Tag
                    </strong>.
                    Für das Hauptfutter wurden
                    90 % des Energiebedarfs angesetzt.
                  </li>
                `
                : `
                  <li>
                    Snacks und Leckerlis wurden bei dieser
                    Berechnung nicht berücksichtigt und liefern
                    zusätzliche Energie.
                  </li>
                `;


            const mealHtml =
              stage === 'adult'
                ? `
                  <p>
                    Bei zwei Mahlzeiten entspricht das rechnerisch
                    etwa
                    <strong>
                      ${fmt0(
                        gramsPerDay /
                        2
                      )} g pro Mahlzeit
                    </strong>.
                  </p>
                `
                : '';


            result.innerHTML = `
              <h3>
                🐕 Dein Orientierungswert
              </h3>

              <div class="wsfc__result-grid">

                <div class="wsfc__metric">
                  Geschätzter Tagesenergiebedarf

                  <strong>
                    ${fmt0(
                      dailyEnergy
                    )} kcal
                  </strong>
                </div>


                <div class="wsfc__metric">
  Orientierende ${foodTypeLabel}-Menge

  <strong>
    ca.
    ${fmt0(
      gramsPerDay
    )} g/Tag
  </strong>
</div>


              ${mealHtml}

              ${estimateHtml}


              <ul>

                <li>
  Grundlage:
  ${fmt1(weight)} kg ·
  ${stageDescription} ·
  ${foodTypeLabel} ·
  ${fmt0(kcal100)} kcal/100 g.
</li>

                ${treatHtml}

                <li>
                  ${bcsNote(
                    $('#wsfc-bcs').value
                  )}
                </li>

              </ul>


              ${
                stage === 'puppy'
                  ? puppyResultNote()
                  : ''
              }


              <p>
                <strong>
                  Bitte beobachte Gewicht und Körperkondition.
                </strong>

                Individuelle Energiebedarfe können deutlich
                von berechneten Ausgangswerten abweichen.
              </p>
            `;


            result.hidden =
              false;


            scrollToResult(
              result
            );

          } catch (error) {

            showError(
              'amount',
              error.message ||
              'Bitte prüfe deine Angaben.'
            );

          }

        }
      );


    /*
      MISCHFÜTTERUNG SLIDER
    */

    $('#wsfc-mix-slider')
      .addEventListener(
        'input',
        event => {

          const dry =
            parseInt(
              event.target.value,
              10
            );


          $('[data-wsfc-dry-share]')
            .textContent =
              dry;


          $('[data-wsfc-wet-share]')
            .textContent =
              100 - dry;

        }
      );


    /*
      MISCHFÜTTERUNG BERECHNEN
    */

    $('[data-wsfc-form="mixed"]')
      .addEventListener(
        'submit',
        event => {

          event.preventDefault();

          clearFeedback(
            'mixed'
          );


          try {

            if (
              !$('#wsfc-mix-healthy')
                .checked
            ) {

              throw new Error(
                'Bitte bestätige, dass der Rechner für einen grundsätzlich gesunden Hund verwendet wird.'
              );

            }


            const stage =
              $('#wsfc-mix-stage').value;


            const weight =
              numberValue(
                '#wsfc-mix-weight'
              );


            const activityFactor =
              numberValue(
                '#wsfc-mix-activity'
              );


            const matureWeight =
              numberValue(
                '#wsfc-mix-mature'
              );


            const dailyEnergy =
              getBaseEnergy(
                stage,
                weight,
                activityFactor,
                matureWeight
              );


            const reserveTreats =
              $('#wsfc-mix-treats')
                .checked;


            const mainFoodEnergy =
              reserveTreats
                ? dailyEnergy * 0.90
                : dailyEnergy;


            const dryEntered =
              numberValue(
                '#wsfc-dry-energy'
              );


            const wetEntered =
              numberValue(
                '#wsfc-wet-energy'
              );


            if (
              !isFiniteNumber(
                dryEntered
              ) ||
              dryEntered <= 0 ||
              !isFiniteNumber(
                wetEntered
              ) ||
              wetEntered <= 0
            ) {

              throw new Error(
                'Bitte gib für Trocken- und Nassfutter jeweils den Energiegehalt ein.'
              );

            }


            const dryKcal100 =
              kcalPer100(
                dryEntered,
                $('#wsfc-dry-unit').value
              );


            const wetKcal100 =
              kcalPer100(
                wetEntered,
                $('#wsfc-wet-unit').value
              );


            validateEnergy(
              dryKcal100
            );


            validateEnergy(
              wetKcal100
            );


            const dryShare =
              parseInt(
                $('#wsfc-mix-slider').value,
                10
              ) /
              100;


            const wetShare =
              1 -
              dryShare;


            const dryEnergy =
              mainFoodEnergy *
              dryShare;


            const wetEnergy =
              mainFoodEnergy *
              wetShare;


            const dryGrams =
              dryEnergy /
              (
                dryKcal100 /
                100
              );


            const wetGrams =
              wetEnergy /
              (
                wetKcal100 /
                100
              );


            const result =
              $(
                '[data-wsfc-result="mixed"]'
              );


            result.innerHTML = `
              <h3>
                🥣 Deine Mischfütterung
              </h3>

              <div class="wsfc__result-grid">

                <div class="wsfc__metric">
                  Tagesenergiebedarf

                  <strong>
                    ${fmt0(
                      dailyEnergy
                    )} kcal
                  </strong>
                </div>


                <div class="wsfc__metric">
                  Für Hauptfutter angesetzt

                  <strong>
                    ${fmt0(
                      mainFoodEnergy
                    )} kcal
                  </strong>
                </div>


                <div class="wsfc__metric">
                  Trockenfutter ·
                  ${Math.round(
                    dryShare *
                    100
                  )} % Energie

                  <strong>
                    ca.
                    ${fmt0(
                      dryGrams
                    )} g/Tag
                  </strong>
                </div>


                <div class="wsfc__metric">
                  Nassfutter ·
                  ${Math.round(
                    wetShare *
                    100
                  )} % Energie

                  <strong>
                    ca.
                    ${fmt0(
                      wetGrams
                    )} g/Tag
                  </strong>
                </div>

              </div>


              <p>
                <strong>
                  Wichtig:
                </strong>

                Die Aufteilung erfolgt nach Energieanteil
                und nicht nach gleicher Grammmenge.
              </p>


              ${
                reserveTreats
                  ? `
                    <p>
                      Bis zu ca.
                      <strong>
                        ${fmt0(
                          dailyEnergy *
                          0.10
                        )} kcal
                      </strong>
                      wurden für Snacks reserviert.

                      10 % sind eine Obergrenze
                      für Extras, kein Ziel.
                    </p>
                  `
                  : `
                    <p>
                      Snacks und Leckerlis wurden bei
                      dieser Berechnung nicht berücksichtigt
                      und liefern zusätzliche Energie.
                    </p>
                  `
              }


              ${
                stage === 'puppy'
                  ? puppyResultNote()
                  : ''
              }


              <p>
                Die Werte sind Orientierungswerte.
                Gewicht und Körperkondition regelmäßig
                kontrollieren und die Fütterung
                bei Bedarf anpassen.
              </p>
            `;


            result.hidden =
              false;


            scrollToResult(
              result
            );

          } catch (error) {

            showError(
              'mixed',
              error.message ||
              'Bitte prüfe deine Angaben.'
            );

          }

        }
      );


    /*
      TROCKENSUBSTANZ BERECHNEN
    */

    $('[data-wsfc-form="dm"]')
      .addEventListener(
        'submit',
        event => {

          event.preventDefault();

          clearFeedback(
            'dm'
          );


          try {

            const nutrientA =
              numberValue(
                '#wsfc-a-nutrient'
              );


            const moistureA =
              numberValue(
                '#wsfc-a-moisture'
              );


            if (
              !isFiniteNumber(
                nutrientA
              ) ||
              !isFiniteNumber(
                moistureA
              ) ||
              nutrientA < 0 ||
              moistureA < 0 ||
              moistureA >= 100
            ) {

              throw new Error(
                'Bitte fülle Futter A vollständig und korrekt aus.'
              );

            }


            const dryMatterA =
              100 -
              moistureA;

if (
  nutrientA > dryMatterA
) {
  throw new Error(
    'Der Nährstoffwert von Futter A kann nicht höher sein als die vorhandene Trockensubstanz. Bitte prüfe deine Angaben.'
  );
}

            const nutrientDMA =
              (
                nutrientA /
                dryMatterA
              ) *
              100;


            const nutrientB =
              numberValue(
                '#wsfc-b-nutrient'
              );


            const moistureB =
              numberValue(
                '#wsfc-b-moisture'
              );


            const hasAnyB =
              isFiniteNumber(
                nutrientB
              ) ||
              isFiniteNumber(
                moistureB
              );


            let compareHtml =
              '';


            if (hasAnyB) {

              if (
                !isFiniteNumber(
                  nutrientB
                ) ||
                !isFiniteNumber(
                  moistureB
                ) ||
                nutrientB < 0 ||
                moistureB < 0 ||
                moistureB >= 100
              ) {

                throw new Error(
                  'Bitte fülle Futter B vollständig aus oder lasse beide Felder leer.'
                );

              }


              const dryMatterB =
                100 -
                moistureB;

                if (
  nutrientB > dryMatterB
) {
  throw new Error(
    'Der Nährstoffwert von Futter B kann nicht höher sein als die vorhandene Trockensubstanz. Bitte prüfe deine Angaben.'
  );
}


              const nutrientDMB =
                (
                  nutrientB /
                  dryMatterB
                ) *
                100;


              compareHtml = `
                <div class="wsfc__metric">

                  Futter B · Trockensubstanz

                  <strong>
                    ${fmt1(
                      dryMatterB
                    )} %
                  </strong>

                </div>


                <div class="wsfc__metric">

                  Futter B · Nährstoff auf TS-Basis

                  <strong>
                    ${fmt1(
                      nutrientDMB
                    )} %
                  </strong>

                </div>
              `;

            }


            const result =
              $(
                '[data-wsfc-result="dm"]'
              );


            result.innerHTML = `
              <h3>
                🧪 Trockensubstanz-Ergebnis
              </h3>

              <div class="wsfc__result-grid">

                <div class="wsfc__metric">

                  Futter A · Trockensubstanz

                  <strong>
                    ${fmt1(
                      dryMatterA
                    )} %
                  </strong>

                </div>


                <div class="wsfc__metric">

                  Futter A · Nährstoff auf TS-Basis

                  <strong>
                    ${fmt1(
                      nutrientDMA
                    )} %
                  </strong>

                </div>


                ${compareHtml}

              </div>


              <p>
                <strong>
                  Formel:
                </strong>

                Nährstoff % ÷
                Trockensubstanz % × 100.
              </p>


              <p>
                So lassen sich Nährstoffangaben von Futtern
                mit sehr unterschiedlichem Wassergehalt
                sinnvoller vergleichen.

                Die Trockensubstanz allein sagt jedoch nicht,
                ob ein Futter für deinen Hund geeignet oder
                bedarfsdeckend ist.
              </p>
            `;


            result.hidden =
              false;


            scrollToResult(
              result
            );

          } catch (error) {

            showError(
              'dm',
              error.message ||
              'Bitte prüfe deine Angaben.'
            );

          }

        }
      );

  }


  /*
    RECHNER STARTEN,
    WENN DER BLOG-PLATZHALTER
    VORHANDEN IST
  */

  onReady(
    () => {

      const root =
        document.getElementById(
          ROOT_ID
        );


      if (!root) {
        return;
      }


      injectStyles();


      init(
        root
      );

    }
  );

})();